<template>
  <div class="batch-flow-container">
    <!-- 顶部 -->
    <el-row>
      <el-col :span="24">
        <div class="content-col">
          <div class="content-title">流程名称</div>
          <div class="init-content top-title">
            {{
              processDetail.process
                ? processDetail.process.processDefinitionName
                : ""
            }}
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">发起人</div>
          <div class="init-content">{{processDetail.process?processDetail.process.startUsername:''}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">流水号</div>
          <div class="init-content">{{basicInfoData.number?basicInfoData.number:''}}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="content-col">
          <div class="content-title">修改时间</div>
          <div class="init-content">{{ basicInfoData.updateTime }}</div>
        </div>
      </el-col>
    </el-row>

    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true">
      <el-tab-pane label="审批信息" name="first">
        <div class="panel-container">
          
          <DetailList
            ref="commonForm"
            :listData="basicInfoData"
            :flowData="flowData"
            :status="
              processDetail.process && processDetail.process.status
                ? processDetail.process.status
                : 'done'
            "
          />
          <!-- 审批意见 -->
          <AuditInfo
            ref="auditInfo"
            :formDetailData="auditFormData"
            :isEditable="
              processDetail.process ? processDetail.process.isEditable : false
            "
            :status="
              processDetail.process && processDetail.process.status
                ? processDetail.process.status
                : 'done'
            "
            @changeFormData="changeFormData"
          />
          <!-- 会签意见 -->
          <CommentStep
            ref="commentStep"
            :commentList="commentList"
            :status="
              processDetail.process && processDetail.process.status
                ? processDetail.process.status
                : 'done'
            "
          />
          <!-- 流程记录 -->
          <CommentTable :flowData="flowData" />

          <!-- 与navbar同高的块 -->
          <div class="bottom-block" style="height: 2.2rem" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="公共附件" name="second">
        <BatchFileList
          v-if="uploadPermissionNameOne"
          :dynamicId="$route.params.id"
          :fileMenuUrlname="uploadPermissionNameOne"
          :fileMenuName="uploadPermissionNameTwo"
          :fileOtherId="$route.params.id"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="会签意见" name="third">
        <CommentStep
          :commentList="commentList"
          :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
        />
      </el-tab-pane> -->
    </el-tabs>

    <BottomLine
      ref="bottoms"
      v-if="processDetail.process && processDetail.process.status == 'todo'"
      :processDetail="processDetail"
      :formDetailData="auditFormData"
      :mobileFormChange="mobileFormChange"
      @flowNext="flowNextBefore"
      @flowBack="flowBack"
      @refreshData="refreshData"
    />
  </div>
</template>
<script>
import Vue from "vue";
import * as api from "@/api/rd/contract";
import BatchFileList from "../../components/batchFileList";
import AuditInfo from "@/components/workflowComponents/mobile/auditInfo";
import BottomLine from "@/components/workflowComponents/mobile/bottomLine";
import CommentTable from "@/components/workflowComponents/mobile/commentTable";
import CommentStep from "@/components/workflowComponents/mobile/commentStep";
import SelectDrawer from "@/components/workflowComponents/mobile/selectDrawer";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { mapGetters } from "vuex";
// 业务明细
import DetailList from "./components/list";


export default {
  name: "mobileTravel",
  mixins: [workFlow, util],
  data() {
    return {
      batchVisible: true,
      id: "",
      activeName: "first",
      flowableId: "",
      auditStatus: "",
      tableData: [],
      basicInfoData: {},
      // 流水号
      flowNumber: "",
      processKey: "process_financial_biz",
    };
  },
  components: {
    AuditInfo,
    BatchFileList,
    BottomLine,
    CommentTable,
    CommentStep,
    SelectDrawer,
    DetailList
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.id = this.$route.params.id;
    this.queryDetail(this.id);
  },
  methods: {
    queryDetail(id) {
      api
        .contractinfo({ id: id })
        .then(async (res) => {
          let basicInfoData = res.data.data;
          let dataList = [{ code: "project_build_state", name: "auditState" }];
          let dataSource = await this.dictionaryMap(dataList, basicInfoData);
          
          dataSource.guaranteeStartDate= dataSource.rdProjectVO.guaranteeStartDate +
              (dataSource.rdProjectVO.guaranteeStartDate &&
              dataSource.rdProjectVO.guaranteeEndDate
                ? "至"
                : "") +
                dataSource.rdProjectVO.guaranteeEndDate
          this.basicInfoData = dataSource;
          // this.getContractDetail(dataSource.contractId);
          
          this.flowableId = this.basicInfoData.flowableId;
          this.flowNumber = this.basicInfoData.number;
          // 查询当前流程任务数据
          // this.queryFlowTaskDetail(res.data.data.flowableId?res.data.data.flowableId:'', this.basicInfoData.auditStatus)
          
          await this.queryFlowData(this.flowableId);
          this.processKey = this.processDetail.process.processDefinitionKey;
          this.processDefinedId = await this.userQueryProcessDefinedId(
            this.processKey
          );
          // 设置流程表单路径
          this.queryProcessFormDetail(this.processDefinedId); 

          
        })
        .catch((res) => {});
    },
   
    
   
    flowNextBefore(formData,taskInfoList) {
      
      this.flowNext(formData,taskInfoList);
      
    },
   

    async flowNext(formData,taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName
      // 流程表单数据

      let variables = formData;

      let res= {
        data:{
          code:'',
          msg:'失败'
        }
      }
      if(taskInfoList&&taskInfoList.length>0){
           res= await this.selectPeopleFlowNext(
                taskId,
                taskName,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables,
                JSON.stringify(taskInfoList),
            )
        
        }else {
           res= await this.taskFlowNext(
                taskId,
                processInsId,
                this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                variables
            )
        }
      if (res.data.code == 200) {
        // this.$notify.success('转交下一步操作成功');
        this.$refs.bottoms.closeDialog();
        this.refreshData();
        this.$message({
          message: "转交下一步操作成功",
          type: "success",
        });
        // 刷新数据
        // this.refreshData()
        // this.$forceUpdate()
        // 跳转结果页
      } else {
        // this.$notify.warn(res.data.msg);
        this.$message({
          message: res.data.msg,
          type: "warning",
        });
      }
    },

    refreshData() {
      this.queryDetail(this.id);
      // this.getBasicConfigData()
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-flow-container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #f9f9f9;
  .top-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 0.3rem;
  }
  /deep/ .el-tabs.el-tabs--top {
    border-top: 0.5px solid #f2f2f2;
    .el-tabs__header {
      background-color: #fff;
    }
    .el-tabs__item {
      font-size: .38rem !important;
    }
  }
  /deep/ .el-message {
    min-width: 7rem !important;
  }
  .content-col {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-bottom: 0.5px solid #f2f2f2;
    background: #fff;
    .content-title {
      text-align: center;
      font-size: 0.38rem;
      line-height: 0.5rem;
      height: 0.5rem;
      color: #333;
    }
    .init-content {
      margin-top: .1rem;
      color: #333;
      font-size: .36rem;
      line-height: 0.5rem;
      height: 0.5rem;
      text-align: center;
    }
  }
  .panel-container {
    width: 100%;
    // padding-left: .25rem;
    // padding-right: .25rem;
  }
  .mobile-audit-roll-back-container {
    // background-color: #f9f9f9;
    width: 100%;
    height: 100%;
    .roll-back-title {
      width: 100%;
      text-align: center;
      font-weight: 600;
      color: #333;
      font-size: 0.45rem;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      background-color: #fff;
    }
    .el-table {
      width: 100%;
      // padding: .25rem .3rem;
    }
    .comment-content {
      width: 100%;
      padding: 0.2rem 0.3rem 0.3rem;
      background-color: #fff;
      margin-top: 0.25rem;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      .comment-title {
        font-size: 0.38rem;
        color: #999;
        line-height: 0.75rem;
      }
      .el-textarea {
        font-size: .38rem;
        color: #333;
      }
    }
    .submit-button-con {
      width: 70%;
      margin-top: 0.25rem;
      text-align: center;
      margin: 0.25rem auto 0;
      .el-button {
        width: 100%;
      }
    }
  }
  /deep/ .el-tabs.el-tabs--top {
    border-top: 0.5px solid #f2f2f2;
    .el-tabs__header {
      background-color: #fff;
    }
    .el-tabs__item {
      font-size: .38rem !important;
    }
  }
  /deep/ .el-message {
    min-width: 7rem !important;
  }
  .content-col {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-bottom: 0.5px solid #f2f2f2;
    background: #fff;
    .content-title {
      text-align: center;
      font-size: 0.38rem;
      line-height: 0.5rem;
      height: 0.5rem;
      color: #333;
    }
    .init-content {
      margin-top: .1rem;
      color: #333;
      font-size: .36rem;
      line-height: 0.5rem;
      height: 0.5rem;
      text-align: center;
    }
  }
  .panel-container {
    width: 100%;
    // padding-left: .25rem;
    // padding-right: .25rem;
  }
}
</style>